import { Component, OnInit } from '@angular/core';
import { TranslationLoaderFacade } from '../../localization/translation-loader.facade';

@Component({
  selector: 'app-tenant-licensing',
  templateUrl: './tenant-licensing.component.html',
  styleUrls: ['./tenant-licensing.component.scss']
})
export class TenantLicensingComponent implements OnInit {

  constructor(private translationLoaderFacade: TranslationLoaderFacade) { }

  ngOnInit() {
  }

}
